import React, { Suspense, lazy } from 'react';
import { MessageCircle, Phone, Star, ChevronRight } from 'lucide-react';
import { businessInfo } from '../../data/mock';

const Spline = lazy(() => import('@splinetool/react-spline'));

export const HeroSection = () => {
  return (
    <section id="beranda" className="relative min-h-screen bg-black overflow-hidden">
      {/* Grid Pattern Overlay */}
      <div 
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage: `
            repeating-linear-gradient(0deg, transparent, transparent 1px, transparent 1px, transparent calc(100% / 13)),
            repeating-linear-gradient(90deg, #fff 0, #fff 1px, transparent 1px, transparent calc(100% / 13))
          `,
          backgroundSize: '100% 100%'
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-5 lg:px-[7.6923%] pt-32 pb-20">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12 lg:gap-8">
          {/* Left Content */}
          <div className="flex-1 max-w-2xl">
            {/* Rating Badge */}
            <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 px-4 py-2 mb-8">
              <div className="flex items-center gap-1">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-[#00FFD1] text-[#00FFD1]" />
                ))}
              </div>
              <span className="text-white/80 text-sm">
                {businessInfo.rating} ({businessInfo.totalReviews} Ulasan)
              </span>
            </div>

            {/* Main Headline */}
            <h1 className="text-white text-4xl md:text-5xl lg:text-[66px] font-semibold leading-[1.1] tracking-[-0.62px] mb-6">
              Jasa Root & Flash Android{' '}
              <span className="text-[#00FFD1]">Profesional</span>
            </h1>

            {/* Subheadline */}
            <p className="text-white/60 text-xl md:text-2xl font-normal mb-4">
              di Bekasi, Tambun, Cibitung, dan Cikarang
            </p>

            {/* Trust Indicators */}
            <div className="flex items-center gap-6 mb-10">
              <span className="text-[#00FFD1] font-medium">Aman</span>
              <span className="text-white/30">•</span>
              <span className="text-[#00FFD1] font-medium">Cepat</span>
              <span className="text-white/30">•</span>
              <span className="text-[#00FFD1] font-medium">Terpercaya</span>
            </div>

            {/* Description */}
            <p className="text-white/70 text-lg leading-relaxed mb-10 max-w-xl">
              NOZEN FLASHER adalah layanan jasa root dan flash Android profesional 
              dengan teknisi berpengalaman. Kami menangani berbagai masalah software 
              Android dari bootloop hingga mati total.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href={businessInfo.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center justify-between gap-3 bg-[#00FFD1] hover:bg-[#00FFD1]/10 text-black hover:text-[#00FFD1] px-6 py-4 min-h-[56px] font-medium text-lg transition-all duration-400"
              >
                <span className="flex items-center gap-3">
                  <MessageCircle className="w-5 h-5" />
                  WhatsApp Sekarang
                </span>
                <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </a>
              <a
                href={`tel:${businessInfo.phone}`}
                className="group inline-flex items-center justify-between gap-3 bg-white/10 hover:bg-white text-white hover:text-black px-6 py-4 min-h-[56px] font-medium text-lg transition-all duration-400"
              >
                <span className="flex items-center gap-3">
                  <Phone className="w-5 h-5" />
                  Hubungi Kami
                </span>
                <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </a>
            </div>
          </div>

          {/* Right Content - Spline 3D */}
          <div className="flex-1 w-full lg:w-auto">
            <div className="relative w-full h-[400px] lg:h-[600px] lg:w-[600px] overflow-visible">
              <Suspense 
                fallback={
                  <div className="w-full h-full flex items-center justify-center">
                    <div className="w-16 h-16 border-2 border-[#00FFD1] border-t-transparent rounded-full animate-spin" />
                  </div>
                }
              >
                <Spline scene="https://prod.spline.design/NbVmy6DPLhY-5Lvg/scene.splinecode" />
              </Suspense>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black to-transparent" />
    </section>
  );
};
